import MainHeader from "../components/MainHeader/MainHeader";
import MainAbout from "../components/MainAbout/MainAbout";
import MainShare from "../components/MainShare/MainShare";
import HowItWorks from "../components/HowItWorks/HowItWorks";
import TutorialPreview from "../components/TutorialPreview/TutorialPreview";
import JoinCommunity from "../components/JoinCommunity/JoinCommunity";
import { Helmet } from "react-helmet-async";

const Glavni = () => {
  return (
    <div style={{ minHeight: '100vh' }}>
      <Helmet>
        <title>Distortion Grids Platform – Browse Tutorials and Guides</title>
        <meta
          name="description"
          content="Discover the latest tutorials, learn how distortion grids work, and jump into the full library of camera and lens presets on Matchmove machine."
        />
        <meta property="og:title" content="Distortion Grids Platform – Browse Tutorials and Guides" />
        <meta
          property="og:description"
          content="Discover the latest tutorials, learn how distortion grids work, and jump into the full library of camera and lens presets on Matchmove machine."
        />
      </Helmet>
      <MainHeader />
      <MainAbout />
      <MainShare />
      <HowItWorks />
      <TutorialPreview />
      <JoinCommunity />
    </div>
  );
};

export default Glavni;